import type { RootState } from '@generalTypes/rootStateTypes';
import { getAngularService } from '@kathondvla/react-shared-components/src/helpers/angularReactHelper';
import { selectExternalGoalOrItem } from '@newStore/llinkid/llinkidSelectors';
import { formatVersion } from '@store/helpers/documentHelpers';
import { useSelector } from 'react-redux';

const AsideLlinkidItem = ({ href }) => {
  const $translate = getAngularService('$translate');

  const goal = useSelector((state: RootState) => selectExternalGoalOrItem(state, href));

  return (
    <>
      <div className="col-md-11 indented">
        <span
          dangerouslySetInnerHTML={{
            __html: goal?.descriptionText,
          }}
        />
      </div>
      <div className="col-md-1 indented">
        {goal?.version &&
          $translate.instant('components.llinkid.goalRelations.fromVersion', {
            version: formatVersion(goal?.version),
          })}
      </div>
    </>
  );
};

export default AsideLlinkidItem;
